import CONFIG from "./../config.json";
import {browserGetCookie, browserSetCookie} from "./browser.js";
import {i18nText} from "./i18n.js";
import {Log} from "./log.js";
const COOKIE_NAME = "subscription-src";
const SUBSCRIPTION_OFFER_COOKIE = "subscription-offer-dismissed"; // avoid showing the pop-up again
const SUBSCRIPTION_SUBSCRIBED_COOKIE = "subscription-subscribed"; // user already subscribed
const OFFER_DELAY_MS = 60000; // grace period to indicate interest (1 minute)
const SUBSCRIPTION_OFFER_DEADLINE_COOKIE = "subscription-offer-deadline"; // timestamp(ms) when popup should show
const SUBSCRIPTION_VISIT_STATUS_COOKIE = "subscription-visit-status"; // remember last /visit HTTP status for the day

// Avoid repeated requests for the same email
const SUBSCRIPTION_SENT_PREFIX = "subscription-sent:"; // localStorage key prefix
const _pendingEmails = new Set();

function _normEmail(email) {
    return (email || "").trim().toLowerCase();
}

function _hasSentTo(email) {
    const key = SUBSCRIPTION_SENT_PREFIX + _normEmail(email);
    try {
        return localStorage.getItem(key) === "true";
    } catch (e) {
        return false;
    }
}

function _markSent(email) {
    const key = SUBSCRIPTION_SENT_PREFIX + _normEmail(email);
    try {
        localStorage.setItem(key, "true");
    } catch (e) {
        // ignore storage errors
    }
}


function subscriptionSendNewConnection() {

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    // send one a day
    // If we already sent today and there's no token, consult last visit status.
    // If last visit returned 401, schedule the offer anyway for today's new connections.
    if (!token && browserGetCookie(COOKIE_NAME)){
        const lastStatus = browserGetCookie(SUBSCRIPTION_VISIT_STATUS_COOKIE);
        if (lastStatus === "401") {
            _scheduleSubscriptionOffer();
        }
        return;
    }

    browserSetCookie(COOKIE_NAME, "posters", 1);

    const url = new URL(`${CONFIG.subscription_url}/api/user/posters/visit`);
    if (token) {
        url.searchParams.append("token", token);
    }

    try {
        fetch(url, {
            method: "GET",
            credentials: 'include'
        }).then(resp => {
            try { browserSetCookie(SUBSCRIPTION_VISIT_STATUS_COOKIE, String(resp && resp.status || ''), 1); } catch (_) {}
            // If not authenticated, offer email subscription after a grace period
            if (resp && resp.status === 401) {
                _scheduleSubscriptionOffer();
            }
        }).catch(e => {
            // Ignore network errors here
            try { browserSetCookie(SUBSCRIPTION_VISIT_STATUS_COOKIE, 'error', 1); } catch (_) {}
        });
    } catch (e) {
        Log.print('Subscription Send New Connection Error:' + e);
    }

}


function subscriptionLoadForm() {
    const mainSubscriptionDiv = document.getElementById('mainSubscription');
    const text = i18nText();
    const language = document.documentElement.lang.toLowerCase().startsWith('es') ? 'es' : 'ca';

    if (!mainSubscriptionDiv)
        return;

    mainSubscriptionDiv.innerHTML = `
        <div class="subscription-container">
            <div id="subscription-title">
                <img class="subscription-title-image" src="/images/yuppiya-segueix-nos-${language}-v1.webp" alt="${text.followUs}">
            </div>
            <p class="subscription-description">${text.subscriptionDescription}</p>
            <form id="subscription-form">                
                <input type="email" id="email" name="email" placeholder="${text.emailPlaceholder}" required>
                <button type="button" id="subscribe-button">${text.subscribe}</button>
            </form>
            <div id="subscription-status" class="subscription-status" aria-live="polite"></div>
        </div>

        <!-- Pop-up Modal -->
        <div id="subscription-modal" class="subscription-modal">
            <div class="subscription-modal-content">                     
                <div>${text.subscriptionIntro}</div> 
                <div>${text.subscriptionVerify}</div> 
                <div>${text.subscriptionContinue}</div>    
                <div style="margin-top:1em;";>
                  <button id="subscription-confirm-button">OK</button>
                  <button id="subscription-cancel-button">${text.cancelShort}</button>
                </div>
            </div>
        </div>
    `;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const statusEl = document.getElementById("subscription-status");
    const subscribeBtn = document.getElementById("subscribe-button");
    const confirmBtn = document.getElementById("subscription-confirm-button");
    const cancelBtn = document.getElementById("subscription-cancel-button");

    function setStatus(message, isError = false) {
        if (!statusEl) return;
        statusEl.textContent = message || "";
        statusEl.style.color = isError ? "#b00020" : "#0a6e00";
    }

    document.getElementById("subscribe-button").addEventListener("click", function () {
        const email = document.getElementById("email").value;

        if (!emailPattern.test(email)) {
            alert(text.invalidEmail);
            return;
        }

        if (_hasSentTo(email)) {
            setStatus(text.alreadySent);
            return;
        }

        document.getElementById("subscription-modal").style.display = "flex";
    });

    document.getElementById("subscription-confirm-button").addEventListener("click", function () {
        const email = document.getElementById("email").value;
        const normEmail = _normEmail(email);

        // Prevent repeated clicks
        subscribeBtn.disabled = true;
        confirmBtn.disabled = true;

        if (_hasSentTo(normEmail) || _pendingEmails.has(normEmail)) {
            document.getElementById("subscription-modal").style.display = "none";
            setStatus(text.alreadySent);
            subscribeBtn.disabled = false;
            confirmBtn.disabled = false;
            return;
        }

        document.getElementById("subscription-modal").style.display = "none";
        _pendingEmails.add(normEmail);

        fetch(`${CONFIG.subscription_url}/api/subscription/petition`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            credentials: 'include',
            body: new URLSearchParams({
                to: email
            })
        })
            .then(response => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.json().catch(() => ({}));
            })
            .then(() => {
                _markSent(normEmail);
                setStatus(text.sentVerification);
            })
            .catch(error => {
                console.log("Hi ha hagut algun problema: " + error);
                setStatus(text.sendProblem, true);
            })
            .finally(() => {
                _pendingEmails.delete(normEmail);
                subscribeBtn.disabled = false;
                confirmBtn.disabled = false;
            });
    });

    document.getElementById("subscription-cancel-button").addEventListener("click", function () {
        document.getElementById("subscription-modal").style.display = "none";
    });
}



// --- Subscription offer popup on 401 ---
let _offerScheduled = false;
let _offerShown = false;

function _scheduleSubscriptionOffer() {
    // Do not nag if already subscribed or recently dismissed
    if (browserGetCookie(SUBSCRIPTION_SUBSCRIBED_COOKIE)) return;
    if (browserGetCookie(SUBSCRIPTION_OFFER_COOKIE)) return;
    if (_offerScheduled || _offerShown) return;

    // Compute remaining delay from cookie (persist across pages)
    function _getRemainingDelayMs() {
        const raw = browserGetCookie(SUBSCRIPTION_OFFER_DEADLINE_COOKIE);
        const now = Date.now();
        if (raw) {
            const deadline = parseInt(raw, 10);
            if (!Number.isNaN(deadline)) {
                const remaining = deadline - now;
                if (remaining > 0) return remaining;
                return 0;
            }
        }
        // Initialize deadline
        const deadline = now + OFFER_DELAY_MS;
        try { browserSetCookie(SUBSCRIPTION_OFFER_DEADLINE_COOKIE, String(deadline), 1); } catch (_) {}
        return OFFER_DELAY_MS;
    }

    const remainingMs = _getRemainingDelayMs();
    _offerScheduled = true;
    setTimeout(() => {
        // Revalidate before showing
        if (browserGetCookie(SUBSCRIPTION_SUBSCRIBED_COOKIE)) return;
        if (browserGetCookie(SUBSCRIPTION_OFFER_COOKIE)) return;
        // Clear deadline cookie to avoid stale past-due values
        try { browserSetCookie(SUBSCRIPTION_OFFER_DEADLINE_COOKIE, "", -1); } catch (_) {}
        _showSubscriptionOfferPopup();
    }, remainingMs);
}

function _showSubscriptionOfferPopup() {
    _offerShown = true;
    const text = i18nText();
    const language = document.documentElement.lang.toLowerCase().startsWith('es') ? 'es' : 'ca';

    const overlay = document.createElement('div');
    overlay.id = 'email-subscribe-popup-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.right = '0';
    overlay.style.bottom = '0';
    overlay.style.background = 'rgba(0,0,0,0.45)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '9999';

    const modal = document.createElement('div');
    modal.style.background = '#fff';
    modal.style.borderRadius = '8px';
    modal.style.padding = '16px';
    modal.style.width = 'min(420px, 92vw)';
    modal.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
    modal.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Arial, sans-serif';
    modal.style.color = 'midnightblue';

    const headingImage = document.createElement('img');
    headingImage.src = `/images/yuppiya-segueix-nos-${language}-v1.webp`;
    headingImage.alt = text.followUs;
    headingImage.style.display = 'block';
    headingImage.style.width = '190px';
    headingImage.style.maxWidth = '100%';
    headingImage.style.height = 'auto';
    headingImage.style.margin = '0 auto 10px';

    const title = document.createElement('div');
    title.textContent = text.offerTitle;
    title.style.fontSize = '18px';
    title.style.fontWeight = '600';
    title.style.marginBottom = '8px';

    const desc = document.createElement('div');
    desc.textContent = text.offerDescription;
    desc.style.fontSize = '14px';
    desc.style.marginBottom = '12px';

    const form = document.createElement('form');
    form.setAttribute('novalidate', 'novalidate');
    form.style.display = 'flex';
    form.style.gap = '8px';
    form.style.alignItems = 'center';
    form.style.marginTop = '4px';

    const emailInput = document.createElement('input');
    emailInput.type = 'email';
    emailInput.placeholder = text.emailPlaceholder;
    emailInput.style.flex = '1';
    emailInput.style.padding = '8px 10px';
    emailInput.style.border = '1px solid #ccc';
    emailInput.style.borderRadius = '6px';

    const subscribeBtn = document.createElement('button');
    subscribeBtn.type = 'submit';
    subscribeBtn.textContent = text.subscribeMe;
    subscribeBtn.style.padding = '8px 12px';
    subscribeBtn.style.border = 'none';
    subscribeBtn.style.background = '#0069d9';
    subscribeBtn.style.color = '#fff';
    subscribeBtn.style.borderRadius = '6px';
    subscribeBtn.style.cursor = 'pointer';

    const laterBtn = document.createElement('button');
    laterBtn.type = 'button';
    laterBtn.textContent = text.later;
    laterBtn.style.marginLeft = '8px';
    laterBtn.style.padding = '8px 12px';
    laterBtn.style.border = '1px solid #ccc';
    laterBtn.style.background = '#fff';
    laterBtn.style.color = '#333';
    laterBtn.style.borderRadius = '6px';
    laterBtn.style.cursor = 'pointer';

    const status = document.createElement('div');
    status.style.marginTop = '10px';
    status.style.fontSize = '13px';

    form.appendChild(emailInput);
    form.appendChild(subscribeBtn);
    form.appendChild(laterBtn);

    modal.appendChild(headingImage);
    modal.appendChild(title);
    modal.appendChild(desc);
    modal.appendChild(form);
    modal.appendChild(status);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    function closeAndRemember(days) {
        try { browserSetCookie(SUBSCRIPTION_OFFER_COOKIE, '1', days); } catch (_) {}
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }

    laterBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Don't nag for some days (30)
        closeAndRemember(30);
    });

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            // Close on outside click and remember
            closeAndRemember(30);
        }
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = (emailInput.value || '').trim();
        if (!emailPattern.test(email)) {
            status.textContent = text.invalidEmail;
            status.style.color = '#b00020';
            return;
        }

        subscribeBtn.disabled = true;
        laterBtn.disabled = true;
        status.textContent = text.sending;
        status.style.color = '#333';

        fetch(`${CONFIG.subscription_url}/api/subscription/petition`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            credentials: 'include',
            body: new URLSearchParams({ to: email })
        })
        .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json().catch(() => ({}));
        })
        .then(() => {
            try { browserSetCookie(SUBSCRIPTION_SUBSCRIBED_COOKIE, '1', 365); } catch (_) {}
            status.textContent = text.sentShort;
            status.style.color = '#0a6e00';
            setTimeout(() => closeAndRemember(365), 1500);
        })
        .catch(() => {
            status.textContent = text.sendProblem;
            status.style.color = '#b00020';
            subscribeBtn.disabled = false;
            laterBtn.disabled = false;
        });
    });
}
export { subscriptionSendNewConnection, subscriptionLoadForm };
